import { Component } from '@angular/core';

@Component({
  selector: 'stars-guest-elements',
  templateUrl: './guest-elements.component.html',
  styleUrls: ['./guest-elements.component.scss']
})
export class GuestElementsComponent {}
